import request from "@/utils/request"
/**
 * 获取广告图
 * @returns Promise
 */

//获取广告轮播图
export const findBanner = (bannerID) => {
  return request('/home/banner', 'get', { bannerID })
}
//获取最新课程
/*  export const findCategory = () => {
   return request('/home/category', 'get')
 } */
//获取人气推荐
export const findHot = () => {
  return request('home/hot', 'get')
}
//获取新课程new
export const findNew = () => {
  return request('home/new', 'get')
}

//获取执业类的课程
export const findZhiYe = (chID) => {
  return request('home/zhiye', 'get', { chID })
}

//获取职称类的课程
export const findZhiCheng = (chID) => {
  return request('home/zhicheng', 'get', { chID })
}

//获取规培类的课程
export const findGuiPei = (chID) => {
  return request('home/guipei', 'get', { chID })
}

//获取规培类的课程
export const findSheBei = (chID) => {
  return request('home/shebei', 'get', { chID })
}

